<template>
  <div class="modal--credential">
    <div class="modalCustom__header">
      <h5 class="">{{ header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <CreateCredentialContent @update:username="username = $event" @update:password="setPassword($event)">
      </CreateCredentialContent>

      <!-- Error Part -->
      <div v-if="catchedErrors" v-for="error in catchedErrors" v-bind:key="error">
        <p class="pt-3 text-custom_red text-sm">{{ error[0] }}</p>
      </div>
      <!-- End Errors Part -->
    </div>
    <div class="modalCustom__footer">
      <!--            buttons                   -->
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div v-if="this.password === this.confirm_password">
        <p-button type="success" round @click.native.prevent="createCredential">
          {{ $t('save') }}
        </p-button>
      </div>
      <div v-else>
        <p-button type="success" :disabled="true" round>
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import axiosAuth from '../../axiosMain';
import VuePassword from '../VuePassword';
import SvgUser from '../svg/SvgUser';
import CreateCredentialContent from './CreateCredentialContent';
import CreateUserContent from './CreateUserContent';
import CancelButton from '../buttons/CancelButton';
import SaveButton from '../buttons/SaveButton';
import CreateNewButton from '../buttons/CreateNewButton';

export default {
  name: 'CreateCredentialModal',
  components: {
    CreateNewButton,
    SaveButton,
    CancelButton,
    CreateUserContent,
    CreateCredentialContent,
    SvgUser,
    VuePassword,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data: function () {
    return {
      username: null,
      password: null,
      first_name: null,
      last_name: null,
      confirm_password: null,
      catchedErrors: null,
      header: '',
      user: {},
      content: {},
      submitTitle: this.$t('create_new'),
    };
  },
  mounted() {
    this.setProps(this.data);
  },
  methods: {
    setPassword: function (event) {
      this.catchedErrors = null;
      this.password = event.password;
      this.confirm_password = event.confirm_password;
    },
    setProps: function (data) {
      this.header = data.header;
      this.user = data.user;
      this.content = data.content;
      this.submitTitle = data.submitTitle;
    },
    closeModal: function () {
      this.username = '';
      this.password = '';
      this.$emit('close');
    },
    createCredential: function () {
      axiosAuth
        .post(
          '/credentials',
          {
            user_id: this.user.user_id,
            username: this.username,
            password: this.password,
            password_confirmation: this.confirm_password,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.closeModal();
          this.$emit('submit', response.data);
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('credentials_were_deleted'),
          });
        })
        .catch((errors) => {
          this.catchedErrors = errors.response.data.errors;
          Object.entries(errors.response.data).forEach((item) => {
            this.$notify({
              type: 'danger',
              title: item[1],
            });
          });
        });
    },
  },
};
</script>

<style scoped></style>
